














import { defineComponent } from 'vue';
import { f7 } from 'framework7-vue';

import { authStoreMapper } from '../store';

import AuthBirthdayIcon from './AuthBirthdayIcon.vue';

export default defineComponent({
  name: 'AuthHomeBirthdayReminder',
  components: { AuthBirthdayIcon },
  computed: {
    show(): boolean {
      return !!this.user?.askBirthday && !!this.user?.idUser;
    },
    ...authStoreMapper.mapGetters(['settings', 'user']),
  },
  methods: {
    onClick() {
      if (this.settings.birthdayReminderProfileEdit) {
        f7.views.current.router.navigate('/profile/edit');
      }
    },
  },
});
